export default ["dev","404.html","blog-post.html","category.html","contacts.html","editorial.html","index.html"]


// WEBPACK FOOTER //
// app/scripts/files.js